module.exports = __webpack_public_path__ + "static/media/faq.a8fda340.jpg";